import {
  Box,
  Circle,
  HStack,
  IconButton,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import {
  FormSelectControl,
  ISelectOption,
} from "../../components/forms/SelectControl";
import { MaterialIcon } from "../../components/shared/MaterialIcon";

interface IProps {
  name: string;
  orderNumber: number;
  onRemove: () => void;
  columns: ISelectOption[];
}

export const FormQueryOrderByPill = ({
  orderNumber,
  name,
  onRemove,
  columns,
}: IProps) => {
  const handleOnRemove = () => {
    onRemove();
  };

  return (
    <HStack spacing={6} px={4} py={3} borderWidth={1} bg="bg.high">
      <Circle bg="bg.higher" minWidth={6}>
        <Text color="text.soft">{orderNumber}</Text>
      </Circle>
      <FormSelectControl
        name={name}
        placeholder=""
        options={columns}
        formControlProps={{
          maxW: "16rem",
        }}
        bg="bg.main"
      ></FormSelectControl>

      <Box>
        <Tooltip label="Remove">
          <IconButton
            onClick={handleOnRemove}
            icon={
              <MaterialIcon
                color="text.soft"
                name="delete"
                fontSize="1.25rem"
                variant="outline"
              />
            }
            aria-label="remove order by column"
          ></IconButton>
        </Tooltip>
      </Box>
    </HStack>
  );
};
